// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container--jnnwx {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.style__header--ch4aR {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.style__modulesContainer--oaeoC {
  overflow: auto;
  padding-top: 0.5rem;
}
.style__moduleTable--USrYx {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid var(--sys-color-outline-variant);
  border-radius: 8px;
  overflow: hidden;
  font-size: 0.875rem;
  table-layout: fixed;
}
.style__moduleTable--USrYx th, .style__moduleTable--USrYx td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid var(--sys-color-outline-variant);
}
.style__moduleTable--USrYx th {
  font-weight: 600;
  color: var(--sys-color-on-surface-variant);
  border-bottom: 2px solid var(--sys-color-outline-variant);
}
.style__moduleTable--USrYx td {
  vertical-align: middle;
}
.style__moduleTable--USrYx tr:last-child td {
  border-bottom: none;
}
.style__moduleTable--USrYx tr:not(.style__groupRow--Ww1tL):hover td {
  background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));
}
.style__groupRow--Ww1tL td {
  background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));
}
.style__groupCell--sbv3d {
  padding: 0.75rem 1rem;
}
.style__thIndex--RsGNv, .style__tdIndex--snnRH {
  width: 3rem;
  text-align: center;
}
.style__thName--Kab3I, .style__tdName--zcVjS {
  width: auto;
}
.style__thGear--SjvdC, .style__tdGear--UBlc3 {
  width: 10rem;
}
.style__thVersions--Ops7p, .style__tdVersions--MhZvW {
  width: 14rem;
  white-space: normal;
  word-break: break-word;
}
.style__thActive--aRZod, .style__tdActive--Z66eW {
  width: 5rem;
  text-align: center;
}
.style__emptyState--h3H5K {
  padding: 2rem 0;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SimModulesPage/style.less"],"names":[],"mappings":"AAEA;EAEI,aAAA;EACA,sBAAA;EACA,SAAA;AAFJ;AAFA;EAQI,aAAA;EACA,mBAAA;EACA,8BAAA;AAHJ;AAPA;EAcI,cAAA;EACA,mBAAA;AAJJ;AAXA;EAmBI,WAAA;EACA,yBAAA;EACA,kDAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AALJ;AApBA;EA4BM,qBAAA;EACA,gBAAA;EACA,yDAAA;AAJN;AA1BA;EAkCM,gBAAA;EACA,0CAAA;EACA,yDAAA;AALN;AA/BA;EAwCM,sBAAA;AANN;AAlCA;EA4CM,mBAAA;AAPN;AArCA;EAgDM,iEAAA;AARN;AAxCA;EAsDM,iEAAA;AAXN;AA3CA;EA2DI,qBAAA;AAbJ;AA9CA;EA+DI,WAAA;EACA,kBAAA;AAbJ;AAnDA;EAoEI,WAAA;AAbJ;AAvDA;EAwEI,YAAA;AAbJ;AA3DA;EA4EI,YAAA;EACA,mBAAA;EACA,sBAAA;AAbJ;AAjEA;EAkFI,WAAA;EACA,kBAAA;AAbJ;AAtEA;EAuFI,eAAA;EACA,kBAAA;AAdJ","sourcesContent":["@import '@yaak/components/src/spacing';\n\n:local {\n  .container {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .modulesContainer {\n    overflow: auto;\n    padding-top: @spacing-50;\n  }\n\n  .moduleTable {\n    width: 100%;\n    border-collapse: collapse;\n    border: 1px solid var(--sys-color-outline-variant);\n    border-radius: 8px;\n    overflow: hidden;\n    font-size: 0.875rem;\n    table-layout: fixed;\n\n    th, td {\n      padding: @spacing-75 @spacing-100;\n      text-align: left;\n      border-bottom: 1px solid var(--sys-color-outline-variant);\n    }\n\n    th {\n      font-weight: 600;\n      color: var(--sys-color-on-surface-variant);\n      border-bottom: 2px solid var(--sys-color-outline-variant);\n    }\n\n    td {\n      vertical-align: middle;\n    }\n\n    tr:last-child td {\n      border-bottom: none;\n    }\n\n    tr:not(.groupRow):hover td {\n      background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));\n    }\n  }\n\n  .groupRow {\n    td {\n      background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));\n    }\n  }\n\n  .groupCell {\n    padding: @spacing-75 @spacing-100;\n  }\n\n  .thIndex, .tdIndex {\n    width: 3rem;\n    text-align: center;\n  }\n\n  .thName, .tdName {\n    width: auto;\n  }\n\n  .thGear, .tdGear {\n    width: 10rem;\n  }\n\n  .thVersions, .tdVersions {\n    width: 14rem;\n    white-space: normal;\n    word-break: break-word;\n  }\n\n  .thActive, .tdActive {\n    width: 5rem;\n    text-align: center;\n  }\n\n  .emptyState {\n    padding: @spacing-200 0;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container--jnnwx`,
	"header": `style__header--ch4aR`,
	"modulesContainer": `style__modulesContainer--oaeoC`,
	"moduleTable": `style__moduleTable--USrYx`,
	"groupRow": `style__groupRow--Ww1tL`,
	"groupCell": `style__groupCell--sbv3d`,
	"thIndex": `style__thIndex--RsGNv`,
	"tdIndex": `style__tdIndex--snnRH`,
	"thName": `style__thName--Kab3I`,
	"tdName": `style__tdName--zcVjS`,
	"thGear": `style__thGear--SjvdC`,
	"tdGear": `style__tdGear--UBlc3`,
	"thVersions": `style__thVersions--Ops7p`,
	"tdVersions": `style__tdVersions--MhZvW`,
	"thActive": `style__thActive--aRZod`,
	"tdActive": `style__tdActive--Z66eW`,
	"emptyState": `style__emptyState--h3H5K`
};
export default ___CSS_LOADER_EXPORT___;
